import useSelector from './useSelector'

const useAccount = () => {
  const storedData = useSelector(state => state.user)

  if (
    !storedData ||
    !storedData.account ||
    !storedData.controlData.isLoggedIn
  ) {
    throw new Error('unauthorized')
  }

  return storedData.account
}

export default useAccount
